import TemplateCardKpiVariant from "./TemplateCardKpiVariant";

export default TemplateCardKpiVariant;
export type { TemplateCardKpiViewProps } from "./TemplateCardKpiVariant";
